import http from "@/services/http";

const get = (params) => http.get("brokers", { params });
const create = (params) => http.post("brokers", params);
const update = (id, params) => http.put(`brokers/${id}`, params);
const show = (id) => http.get(`brokers/${id}`);
const exportPolicies = (params) => http.post("brokers/policies/export-excel", params);

export default {
  get,
  create,
  update,
  show,
  exportPolicies,
};
